import { PaymentMethod } from '@accounting/interfaces/payment-method';
import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import { bpcApi } from '@core/services/bpc-api.service';
import { ShoppingCartResponse, ShoppingCartTicket } from '@accounting/interfaces/shopping-cart';

export default class BPCStripeService {
  protected $bpcApiRouteHelper: BPCApiRouteHelper;
  protected $bpcApi: typeof bpcApi;

  constructor() {
    this.$bpcApiRouteHelper = new BPCApiRouteHelper();
    this.$bpcApi = bpcApi;
  }

  async getPaymentLink(
    paymentMethod: PaymentMethod,
    ticket: ShoppingCartTicket,
  ): Promise<ShoppingCartResponse> {
    const payload = {
      paymentMethod: paymentMethod,
    };
    const path = this.$bpcApiRouteHelper.getApiPath(`shopping-cart/ticket/${ticket.id}/payment`);
    const res = await this.$bpcApi.post(path, payload).toPromise();
    return res.data;
  }
  async getStripeInvoiceCheckout(
    paymentMethod: PaymentMethod,
    invoiceId: number | string,
  ): Promise<ShoppingCartResponse> {
    const payload = {
      payload: {
        invoiceId: invoiceId,
        paymentMethod: paymentMethod,
      },
    };
    const url = `${this.$bpcApiRouteHelper.getEntityPath('invoice')}/online-checkout`;
    const res = await this.$bpcApi.post(url, payload).toPromise();
    return res.data;
  }
}
